import React from "react";
import { MdEdit, MdDelete, MdRemoveRedEye, MdFileDownload } from "react-icons/md";

const MemoireTable = ({ memoires, loading, onEdit, onDelete, onView, onDownload }) => {
  // Formatage de la date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="overflow-hidden rounded-lg shadow-sm border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-700"
            >
              Thème
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden md:table-cell"
            >
              Étudiant
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden lg:table-cell"
            >
              Filière
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden sm:table-cell"
            >
              Date
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden xl:table-cell"
            >
              Établissement
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {loading && memoires.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                <div className="flex justify-center">
                  <svg className="animate-spin h-5 w-5 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              </td>
            </tr>
          ) : memoires.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                <p>Aucun mémoire trouvé</p>
                <p className="text-xs text-gray-400 mt-1">
                  Créez un nouveau mémoire en cliquant sur le bouton "Nouveau Mémoire"
                </p>
              </td>
            </tr>
          ) : (
            memoires.map((memoire) => (
              <tr key={memoire.memoire_id} className="hover:bg-gray-50 transition-colors">
                <td className="py-4 pl-4 pr-3 text-sm">
                  <div className="flex flex-col">
                    <span className="font-medium text-gray-900 truncate max-w-xs">{memoire.memoire_theme}</span>
                    <span className="text-xs text-gray-500 mt-1">{memoire.memoire_annee}</span>
                  </div>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden md:table-cell">
                  {memoire.memoire_etudiant}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden lg:table-cell">
                  {memoire.memoire_filiere}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden sm:table-cell">
                  {formatDate(memoire.memoire_date)}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden xl:table-cell truncate max-w-xs">
                  {memoire.memoire_etablissement}
                </td>
                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => onView(memoire)}
                      className="p-1.5 text-indigo-600 hover:text-indigo-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Voir les détails"
                    >
                      <MdRemoveRedEye className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onDownload(memoire)}
                      className="p-1.5 text-blue-600 hover:text-blue-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Télécharger le PDF"
                    >
                      <MdFileDownload className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onEdit(memoire)}
                      className="p-1.5 text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Modifier"
                    >
                      <MdEdit className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onDelete(memoire)}
                      className="p-1.5 text-red-500 hover:text-red-700 rounded-md hover:bg-gray-100 transition-colors"
                      title="Supprimer"
                    >
                      <MdDelete className="h-5 w-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MemoireTable;